import { formatPhone } from '#/shared/lib/format'
import { CallButton } from './call-button'

export function CardContact({ name, phone }: { name: string; phone?: string }) {
  return (
    <div className="flex items-center justify-between gap-2">
      <div className="flex min-w-0 items-center gap-2.5">
        {name && (
          <span className="truncate text-base font-medium text-gray-900">
            {name}
          </span>
        )}
        {phone && (
          <span className="shrink-0 text-xs text-gray-500">
            {formatPhone(phone)}
          </span>
        )}
      </div>
      <CallButton phone={phone} />
    </div>
  )
}
